import { useEffect, useRef } from "react";

// Observes a sentinel row at the bottom of a scrollable table and calls
// onLoadMore once it scrolls into view, as long as more pages remain.
export const useLoadMoreObserver = (rootRef, hasMore, loadingMore, onLoadMore) => {
  const triggerRef = useRef(null);

  useEffect(() => {
    if (!hasMore) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !loadingMore) {
          onLoadMore();
        }
      },
      { root: rootRef.current, rootMargin: "100px", threshold: 0.1 }
    );

    if (triggerRef.current) {
      observer.observe(triggerRef.current);
    }

    return () => observer.disconnect();
  }, [rootRef, hasMore, loadingMore, onLoadMore]);

  return triggerRef;
};
